/**
 * Le module `fs` vu par server.js : les quelques fonctions qu'il utilise,
 * au-dessus du stockage du navigateur. Les dossiers n'existent pas vraiment :
 * un chemin est une simple clé.
 */
import { fichiers, ecrire, effacer } from '../stockage.js';

function introuvable(chemin) {
  const err = new Error(`ENOENT: ${chemin}`);
  err.code = 'ENOENT';
  return err;
}

function sousChemins(dossier) {
  const prefixe = dossier.endsWith('/') ? dossier : `${dossier}/`;
  return [...fichiers.keys()].filter((c) => c.startsWith(prefixe));
}

export function readFileSync(chemin) {
  if (!fichiers.has(chemin)) throw introuvable(chemin);
  return fichiers.get(chemin);
}

export function writeFileSync(chemin, contenu) {
  ecrire(chemin, String(contenu));
}

export function renameSync(de, vers) {
  if (!fichiers.has(de)) throw introuvable(de);
  ecrire(vers, fichiers.get(de));
  effacer(de);
}

export function mkdirSync() {}

export function existsSync(chemin) {
  return fichiers.has(chemin) || sousChemins(chemin).length > 0;
}

export function readdirSync(dossier) {
  return sousChemins(dossier).map((c) => c.slice(dossier.replace(/\/$/, '').length + 1).split('/')[0]);
}

export function rmSync(chemin, { recursive = false, force = false } = {}) {
  if (fichiers.has(chemin)) effacer(chemin);
  else if (!force && !sousChemins(chemin).length) throw introuvable(chemin);
  if (recursive) for (const c of sousChemins(chemin)) effacer(c);
}

export default { readFileSync, writeFileSync, renameSync, mkdirSync, existsSync, readdirSync, rmSync };
